import AGREGAR_OBRA_SOLICITADA from '@/graphql/mutations/administracion/obrassolicitudes/agregarObraSolicitada.gql';
import ACTUALIZAR_OBRA_SOLICITADA from '@/graphql/mutations/administracion/obrassolicitudes/actualizarObraSolicitada.gql';
import REMOVER_OBRA_SOLICITADA from '@/graphql/mutations/administracion/obrassolicitudes/removerObraSolicitada.gql';
import OBRAS_SOLICITUDES from '@/graphql/querys/administracion/obrassolicitudes/obrasSolicitudes.gql';
import MUNICIPIOS from '@/graphql/querys/administracion/catalogos/municipios/municipios.gql';
import FUENTES_FINANCIERAS from '@/graphql/querys/administracion/catalogos/fuentesfinancieras/fuentesFinancieras.gql';

export default {
  apollo: {
    municipios: {
      query: MUNICIPIOS,
    },
    fuentesFinancieras: {
      query: FUENTES_FINANCIERAS,
    },
  },
  data() {
    return {
      itemsTipoProyecto: ['SOCIAL', 'APOYO', 'PRODUCTIVO'],
      itemsTiposLocalidad: ['COLONIA POPULAR', 'POBLACIÓN RURAL', 'ZONA INDIGENA'],
      itemsModalidadEjecucion: ['CONTRATO', 'ADMON. DIRECTA', 'MIXTA'],
      itemsTiposObra: ['NUEVA', 'AMPLIACIÓN', 'REHABILITACIÓN', 'PROCESO'],
    };
  },
  methods: {
    // Agregar Solicitud de Obra
    async mixAgregarSolicitudObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Subir imagenes de macro y micro localizacion
      if (this.rutaArchivoMicroLocalizacion) {
        const imagenMicrolocalizcion = {
          nombre: 'microlocalizacion',
          path: 'Solicitudes Obras/imagenes',
          imagen: document.getElementById('anexoMicro').files[0],
        };
        await this.mixSubirImagen(imagenMicrolocalizcion, 'micro');
      }
      if (this.rutaArchivoMacroLocalizacion) {
        const imagenMacrolocalizcion = {
          nombre: 'macrolocalizacion',
          path: 'Solicitudes Obras/imagenes',
          imagen: document.getElementById('anexoMacro').files[0],
        };
        await this.mixSubirImagen(imagenMacrolocalizcion, 'macro');
      }

      // Agregar los avances financieros al calendario
      this.solicitudObra.calendario = JSON.stringify(this.avanceFinanciero);

      // Enviar la informacion
      await this.$apollo
        .mutate({
          mutation: AGREGAR_OBRA_SOLICITADA,
          variables: {
            obra: this.solicitudObra,
          },
          update: (store, { data: { agregarObraSolicitada } }) => {
            const query = {
              query: OBRAS_SOLICITUDES,
            };

            const { obrasSolicitudes } = store.readQuery(query);
            obrasSolicitudes.push(agregarObraSolicitada);

            store.writeQuery({
              ...query,
              data: {
                obrasSolicitudes,
              },
            });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Actualizar Solicitud de Obra
    async mixActualizarSolicitudObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Subir imagenes de macro y micro localizacion
      if (this.rutaArchivoMicroLocalizacion && this.rutaArchivoMicroLocalizacion.includes('blob')) {
        const imagenMicrolocalizcion = {
          nombre: 'microlocalizacion',
          path: 'Solicitudes Obras/imagenes',
          imagen: document.getElementById('anexoMicro').files[0],
        };
        await this.mixSubirImagen(imagenMicrolocalizcion, 'micro');
      }

      if (this.rutaArchivoMacroLocalizacion && this.rutaArchivoMacroLocalizacion.includes('blob')) {
        const imagenMacrolocalizcion = {
          nombre: 'macrolocalizacion',
          path: 'Solicitudes Obras/imagenes',
          imagen: document.getElementById('anexoMacro').files[0],
        };
        await this.mixSubirImagen(imagenMacrolocalizcion, 'macro');
      }

      // Agregar los avances financieros actualizados al calendario
      this.solicitudObra.calendario = JSON.stringify(this.avanceFinanciero);

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_OBRA_SOLICITADA,
          variables: {
            id: this.solicitudObraEditar.id,
            obra: this.solicitudObra,
          },
          update: (store, { data: { actualizarObraSolicitada } }) => {
            const query = {
              query: OBRAS_SOLICITUDES,
            };
            const data = store.readQuery(query);
            const { obrasSolicitudes } = data;
            const index = obrasSolicitudes
              .findIndex((obraSolicitud) => obraSolicitud.id
              === actualizarObraSolicitada.id);
            if (index !== -1) {
              obrasSolicitudes.splice(index, 1, actualizarObraSolicitada);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Eliminar Solicitud de Obra
    async mixEliminarSolicitudObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_OBRA_SOLICITADA,
        variables: {
          id: this.solicitudObraEliminar.id,
        },
        update: (store) => {
          const query = {
            query: OBRAS_SOLICITUDES,
          };
          const data = store.readQuery(query);
          const { obrasSolicitudes } = data;
          const index = obrasSolicitudes
            .findIndex((obraSolicitud) => obraSolicitud.id === this.solicitudObraEliminar.id);
          if (index !== -1) {
            obrasSolicitudes.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixSubirImagen(datosImagen, tipo) {
      const dataForm = new FormData();
      dataForm.append('custom_name', datosImagen.nombre);
      dataForm.append('custom_path', datosImagen.path);
      dataForm.append('anexo', datosImagen.imagen);

      await this.axios
        .post(this.$urlFileServer, dataForm, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(({ data }) => {
          const archivo = data;
          if (tipo === 'macro') {
            this.solicitudObra.imagenMacrolocalizacion = archivo.data.public_key;
            return;
          }
          this.solicitudObra.imagenMicrolocalizacion = archivo.data.public_key;
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
    },
  },
  computed: {
    getTiposObras() {
      if (!this.tiposObras) return [];
      return this.tiposObras;
    },
    getMunicipios() {
      if (!this.municipios) return [];
      return this.municipios;
    },
    getFuentesFinancieras() {
      if (!this.fuentesFinancieras) return [];
      return this.fuentesFinancieras;
    },
  },
};
